import {Injectable, Injector} from "@angular/core";
import {Observable} from "rxjs";
import {AbstractHttpService} from "./AbstractHttpService";
import {Especime} from "../../../domain/Especime";

@Injectable()
export class EspecimeHttpService  extends AbstractHttpService<Especime> {
    url = '/api/especime';

    constructor(injector: Injector) {
        super(injector);
    }

    findMapa(): Observable<any>{
        return this.http.get<Especime[]>(this.urlBase + '/findMapa' )
    }

    findExcel(): Observable<any>{
        return this.http.get<Especime[]>(this.urlBase + '/findAll')
    }

    countAll(): Observable<number> {
        return this.http.get<number>(this.urlBase + encodeURI(`/count`))
    }

    sumAll(): Observable<number> {
        return this.http.get<number>(this.urlBase + encodeURI(`/sum`))
    }

    findEspecies(): Observable<any>{
        return this.http.get<Especime[]>(this.urlBase + '/especies')
    }

    countAllRecente(): Observable<number> {
        return this.http.get<number>(this.urlBase + encodeURI(`/countrecente`))
    }

    sumAllRecente(): Observable<number> {
        return this.http.get<number>(this.urlBase + encodeURI(`/sum_recente`))
    }


    countTaxonsDistintos(): Observable<number> {
        return this.http.get<number>(this.urlBase + encodeURI(`/countespecies`))
    }

    countTaxonsDistintosRecente(): Observable<number> {
        return this.http.get<number>(this.urlBase + encodeURI(`/countespeciesrecentes`))
    }

}
